<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li v-if="isHavePermission('receiving:createBuyerReceiveGoods:add')">
            <vxe-radio name="xtabs" label="tab3">托运人订单</vxe-radio>
          </li>
          <li v-if="isHavePermission('receiving:createSellerReceiveGoods:add')">
            <vxe-radio name="xtabs" label="tab1">承运人订单</vxe-radio>
          </li>
          <li
              v-if="isHavePermission('receiving:createSellerLv2ReceiveGoods:add')"
          >
            <vxe-radio name="xtabs" label="tab2">实际供应方订单</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="search-box" v-show="selectTab === 'tab1'">
        <vxe-input
            v-model="filterName1"
            type="search"
            placeholder="请输入订单号"
            @keyup.enter.native="search"
            @search-click="search"
            style="width: 200px; margin-right: 10px"
        ></vxe-input>
        <vxe-input
            v-model="orderName1"
            type="search"
            placeholder="请输入名称"
            @keyup.enter.native="search"
            @search-click="search"
            style="width: 200px"
        ></vxe-input>
      </div>
      <div class="search-box" v-show="selectTab === 'tab2'">
        <vxe-input
            v-model="filterName2"
            type="search"
            placeholder="请输入订单号"
            @keyup.enter.native="search"
            @search-click="search"
            style="width: 200px; margin-right: 10px"
        ></vxe-input>
        <vxe-input
            v-model="orderName2"
            type="search"
            placeholder="请输入名称"
            @keyup.enter.native="search"
            @search-click="search"
            style="width: 200px"
        ></vxe-input>
      </div>
      <div class="search-box" v-show="selectTab === 'tab3'">
        <vxe-input
            v-model="filterName3"
            type="search"
            placeholder="请输入订单号"
            @keyup.enter.native="search"
            @search-click="search"
            style="width: 200px; margin-right: 10px"
        ></vxe-input>
        <vxe-input
            v-model="orderName3"
            type="search"
            placeholder="请输入名称"
            @keyup.enter.native="search"
            @search-click="search"
            style="width: 200px"
        ></vxe-input>
      </div>
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
          border="none"
          align="center"
          show-overflow
          stripe
          highlight-current-row
          max-height="400"
          ref="xTable1"
          class="table-style"
          :auto-resize="true"
          :data="sellerData"
          :loading="loading1"
          @current-change="currentChangeEvent1"
      >
        <vxe-table-column
            field="sellerOrdersNum"
            title="子订单编号"
            width="135"
        ></vxe-table-column>
        <vxe-table-column
            field="contractTitle"
            title="订单标题"
            width="120"
        ></vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="120">
          <template slot-scope="{ row, $rowIndex }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsName
            }}</span>
            <Icon
                type="ios-arrow-down"
                @click.stop="clickEvent3($rowIndex)"
                v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
            />
            <vxe-pulldown :ref="$rowIndex" placement="bottom" transfer>
              <template v-slot:dropdown>
                <div class="my-dropdown3">
                  <vxe-table
                      auto-resize
                      style="width: 860px"
                      :data="row.goodsRtnVos"
                      stripe
                      show-overflow
                      max-height="480"
                      align="center"
                  >
                    <vxe-table-column
                        field="goodsName"
                        title="货名"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="unit"
                        title="单位"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="counts"
                        title="数量"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="amount"
                        title="单价"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column field="isTax" title="含税" width="90">
                      <template slot-scope="{ row }">
                        <span>{{ row.isTax | taxMap }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="carShipNum"
                        title="车船号"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginPlace"
                        title="起运地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="endPlace"
                        title="到达地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
                      <template slot-scope="{ row }">
                        <span>{{ row.beginTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="rule"
            title="规格"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="unit"
            title="单位"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="counts"
            title="数量"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="price"
            title="单价"
            width="90"
        ></vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.isTax | taxMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="carShipNum"
            title="车船号"
            width="130"
        ></vxe-table-column>
        <vxe-table-column
            field="beginPlace"
            title="起运地"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="endPlace"
            title="到达地"
            width="100"
        ></vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page1.currentPage"
          :page-size.sync="page1.pageSize"
          :total="page1.totalResult"
          @page-change="changePage1"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab2'">
      <vxe-table
          border="none"
          show-overflow
          stripe
          align="center"
          highlight-current-row
          max-height="400"
          ref="xTable2"
          class="table-style"
          :auto-resize="true"
          :data="sellerData2"
          :loading="loading2"
          @current-change="currentChangeEvent2"
      >
        <vxe-table-column
            field="sellerOrdersNum"
            title="子订单编号"
            width="135"
        ></vxe-table-column>
        <vxe-table-column
            field="contractTitle"
            title="订单标题"
            width="120"
        ></vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="120">
          <template slot-scope="{ row, $rowIndex }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsName
            }}</span>
            <Icon
                type="ios-arrow-down"
                @click.stop="clickEvent3($rowIndex + 'lv2')"
                v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
            />
            <vxe-pulldown :ref="$rowIndex + 'lv2'" placement="bottom" transfer>
              <template v-slot:dropdown>
                <div class="my-dropdown3">
                  <vxe-table
                      auto-resize
                      style="width: 860px"
                      :data="row.goodsRtnVos"
                      stripe
                      show-overflow
                      align="center"
                  >
                    <vxe-table-column
                        field="goodsName"
                        title="货名"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="unit"
                        title="单位"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="counts"
                        title="数量"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="amount"
                        title="单价"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column field="isTax" title="含税" width="90">
                      <template slot-scope="{ row }">
                        <span>{{ row.isTax | taxMap }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="carShipNum"
                        title="车船号"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginPlace"
                        title="起运地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="endPlace"
                        title="到达地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginTime"
                        title="受载/起运时间"
                        width="140"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.beginTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="rule"
            title="规格"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="unit"
            title="单位"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="counts"
            title="数量"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="price"
            title="单价"
            width="90"
        ></vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.isTax | taxMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="carShipNum"
            title="车船号"
            width="130"
        ></vxe-table-column>
        <vxe-table-column
            field="beginPlace"
            title="起运地"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="endPlace"
            title="到达地"
            width="100"
        ></vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page2.currentPage"
          :page-size.sync="page2.pageSize"
          :total="page2.totalResult"
          @page-change="changePage2"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab3'">
      <vxe-table
          border="none"
          show-overflow
          stripe
          align="center"
          highlight-current-row
          ref="xTable3"
          class="table-style"
          max-height="400"
          :auto-resize="true"
          :data="buyerData"
          :loading="loading3"
          @current-change="currentChangeEvent3"
      >
        <vxe-table-column
            field="buyerOrdersNum"
            title="子订单编号"
            width="135"
        ></vxe-table-column>
        <vxe-table-column
            field="contractTitle"
            title="订单标题"
            width="120"
        ></vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="120">
          <template slot-scope="{ row, $rowIndex }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsName
            }}</span>
            <Icon
                type="ios-arrow-down"
                @click.stop="clickEvent3($rowIndex + 'buyer')"
                v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
            />
            <vxe-pulldown
                :ref="$rowIndex + 'buyer'"
                placement="bottom"
                transfer
            >
              <template v-slot:dropdown>
                <div class="my-dropdown3">
                  <vxe-table
                      auto-resize
                      style="width: 860px"
                      :data="row.goodsRtnVos"
                      stripe
                      show-overflow
                      align="center"
                  >
                    <vxe-table-column
                        field="goodsName"
                        title="货名"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="unit"
                        title="单位"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="counts"
                        title="数量"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="amount"
                        title="单价"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column field="isTax" title="含税" width="90">
                      <template slot-scope="{ row }">
                        <span>{{ row.isTax | taxMap }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="carShipNum"
                        title="车船号"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginPlace"
                        title="起运地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="endPlace"
                        title="到达地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginTime"
                        title="受载/起运时间"
                        width="140"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.beginTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="rule"
            title="规格"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="unit"
            title="单位"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="counts"
            title="数量"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="price"
            title="单价"
            width="90"
        ></vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.isTax | taxMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="carShipNum"
            title="车船号"
            width="130"
        ></vxe-table-column>
        <vxe-table-column
            field="beginPlace"
            title="起运地"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="endPlace"
            title="到达地"
            width="100"
        ></vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page3.currentPage"
          :page-size.sync="page3.pageSize"
          :total="page3.totalResult"
          @page-change="changePage3"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import Auth from "@/utils/auth.js";

  export default {
    mixins: [getAuthOrization],
    props: ["orderId"],
    name: "ChooseRelationOrder",
    data() {
      let userInfoValue = {};
      if (Auth.isLogin()) {
        userInfoValue = Auth.getAuth();
      }
      return {
        userInfoValue,
        sellerOrderNum: null,
        selectTab: "tab3",
        orderName1: null,
        filterName1: null,
        orderName2: null,
        filterName2: null,
        orderName3: null,
        filterName3: null,
        loading1: false,
        loading2: false,
        loading3: false,
        buyerData: [],
        sellerData: [],
        sellerData2: [],
        sellerData3: [],
        page1: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        page2: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        page3: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
      };
    },
    created() {
      if (this.isHavePermission("receiving:createBuyerReceiveGoods:add")) {
        this.selectTab = "tab3";
      } else if (
        this.isHavePermission("receiving:createSellerReceiveGoods:add")
      ) {
        this.selectTab = "tab1";
      } else if (
        this.isHavePermission("receiving:createSellerLv2ReceiveGoods:add")
      ) {
        this.selectTab = "tab2";
      }
    },
    methods: {
      init() {
        this.filterName1 = null;
        this.orderName1 = null;
        this.filterName2 = null;
        this.orderName2 = null;
        this.filterName3 = null;
        this.orderName3 = null;
        (this.page1.currentPage = 1),
          (this.page1.pageSize = 10),
          (this.page2.currentPage = 1),
          (this.page2.pageSize = 10),
          (this.page3.currentPage = 1),
          (this.page3.pageSize = 10),
          this.querySellerOrder();
        this.querySecSellerOrder();
        this.queryBuyerOrder();
      },
      changePage1(e) {
        this.page1.currentPage = e.currentPage;
        this.page1.pageSize = e.pageSize;
        this.querySellerOrder();
      },
      changePage2(e) {
        this.page2.currentPage = e.currentPage;
        this.page2.pageSize = e.pageSize;
        this.querySecSellerOrder();
      },
      changePage3(e) {
        this.page3.currentPage = e.currentPage;
        this.page3.pageSize = e.pageSize;
        this.queryBuyerOrder();
      },
      clickEvent3(id) {
        this.$refs[id].togglePanel();
      },
      currentChangeEvent1({row}) {
        this.$emit("chooseOrder", row, 2, this.orderId);
      },
      currentChangeEvent2({row}) {
        this.$emit("chooseOrder", row, 3, this.orderId);
      },
      currentChangeEvent3({row}) {
        this.$emit("chooseOrder", row, 1, this.orderId);
      },
      search() {
        (this.page1.currentPage = 1),
          (this.page1.pageSize = 10),
          (this.page2.currentPage = 1),
          (this.page2.pageSize = 10),
          (this.page3.currentPage = 1),
          (this.page3.pageSize = 10);

        if (this.selectTab === "tab1") {
          this.querySellerOrder();
        } else if (this.selectTab === "tab2") {
          this.querySecSellerOrder();
        } else if (this.selectTab === "tab3") {
          this.queryBuyerOrder();
        }
      },
      close() {
        this.$refs.xTable1.clearCurrentRow();
        this.$refs.xTable2.clearCurrentRow();
        this.$refs.xTable3.clearCurrentRow();
      },
      async querySellerOrder() {
        // 获取列表数据
        this.loading1 = true;
        let path =
          this.userInfoValue.identityType === 0
            ? "queryOrdersSellerList"
            : "queryOrdersSellerListWithoutPermission";
        let res = await $api.ordersSeller.post(path, {
          sellerOrderNum: this.filterName1,
          sellerName: this.orderName1,
          isSecondSeller: 0,
          page: this.page1.currentPage,
          rows: this.page1.pageSize,
          chainId: this.orderId ? this.orderId : null,
        });

        if (res) {
          this.page1.totalResult = res.data.total;
          let sellerData = res.data.rows;
          sellerData.map((i) => {
            if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
              i.goodsName = i.goodsRtnVos[0].goodsName;
              i.rule = i.goodsRtnVos[0].rule;
              i.unit = i.goodsRtnVos[0].unit;
              i.counts = i.goodsRtnVos[0].counts;
              i.price = i.goodsRtnVos[0].price;
              i.isTax = i.goodsRtnVos[0].isTax;
              i.carShipNum = i.goodsRtnVos[0].carShipNum;
              i.beginPlace = i.goodsRtnVos[0].beginPlace;
              i.endPlace = i.goodsRtnVos[0].endPlace;
              i.beginTime = i.goodsRtnVos[0].beginTime;
              i.createTime = i.goodsRtnVos[0].createTime;
            }
          });
          this.sellerData = sellerData;
          this.loading1 = false;
        }

        // $api.order.queryOrdersSellerListWithoutPermission
        //   .POST({
        //     data: {
        //       sellerOrderNum: this.filterName1,
        //       sellerName: this.orderName1,
        //       isSecondSeller: 0,
        //       page: this.page1.currentPage,
        //       rows: this.page1.pageSize,
        //       chainId: this.orderId ? this.orderId : null,
        //     },
        //   })
        //   .then((res) => {
        //     this.page1.totalResult = res.data.total;
        //     let sellerData = res.data.rows;
        //     sellerData.map((i) => {
        //       if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
        //         i.goodsName = i.goodsRtnVos[0].goodsName;
        //         i.rule = i.goodsRtnVos[0].rule;
        //         i.unit = i.goodsRtnVos[0].unit;
        //         i.counts = i.goodsRtnVos[0].counts;
        //         i.price = i.goodsRtnVos[0].price;
        //         i.isTax = i.goodsRtnVos[0].isTax;
        //         i.carShipNum = i.goodsRtnVos[0].carShipNum;
        //         i.beginPlace = i.goodsRtnVos[0].beginPlace;
        //         i.endPlace = i.goodsRtnVos[0].endPlace;
        //         i.beginTime = i.goodsRtnVos[0].beginTime;
        //         i.createTime = i.goodsRtnVos[0].createTime;
        //       }
        //     });
        //     this.sellerData = sellerData;
        //     this.loading1 = false;
        //   });
      },
      async querySecSellerOrder() {
        // 获取列表数据
        this.loading2 = true;
        let path =
          this.userInfoValue.identityType === 0
            ? "queryOrdersSellerList"
            : "queryOrdersSellerListWithoutPermission";

        let res = await $api.ordersSeller.post(path, {
          sellerOrderNum: this.filterName2,
          sellerName: this.orderName2,
          isSecondSeller: 1,
          page: this.page2.currentPage,
          rows: this.page2.pageSize,
          chainId: this.orderId ? this.orderId : null,
        });

        if (res) {
          this.page2.totalResult = res.data.total;
          let sellerData2 = res.data.rows;
          sellerData2.map((i) => {
            if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
              i.goodsName = i.goodsRtnVos[0].goodsName;
              i.rule = i.goodsRtnVos[0].rule;
              i.unit = i.goodsRtnVos[0].unit;
              i.counts = i.goodsRtnVos[0].counts;
              i.price = i.goodsRtnVos[0].price;
              i.isTax = i.goodsRtnVos[0].isTax;
              i.carShipNum = i.goodsRtnVos[0].carShipNum;
              i.beginPlace = i.goodsRtnVos[0].beginPlace;
              i.endPlace = i.goodsRtnVos[0].endPlace;
              i.beginTime = i.goodsRtnVos[0].beginTime;
              i.createTime = i.goodsRtnVos[0].createTime;
            }
          });
          this.sellerData2 = sellerData2;
          this.loading2 = false;
        }

        // $api.order.queryOrdersSellerListWithoutPermission
        //   .POST({
        //     data: {
        //       sellerOrderNum: this.filterName2,
        //       sellerName: this.orderName2,
        //       isSecondSeller: 1,
        //       page: this.page2.currentPage,
        //       rows: this.page2.pageSize,
        //       chainId: this.orderId ? this.orderId : null,
        //     },
        //   })
        //   .then((res) => {
        //     this.page2.totalResult = res.data.total;
        //     let sellerData2 = res.data.rows;
        //     sellerData2.map((i) => {
        //       if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
        //         i.goodsName = i.goodsRtnVos[0].goodsName;
        //         i.rule = i.goodsRtnVos[0].rule;
        //         i.unit = i.goodsRtnVos[0].unit;
        //         i.counts = i.goodsRtnVos[0].counts;
        //         i.price = i.goodsRtnVos[0].price;
        //         i.isTax = i.goodsRtnVos[0].isTax;
        //         i.carShipNum = i.goodsRtnVos[0].carShipNum;
        //         i.beginPlace = i.goodsRtnVos[0].beginPlace;
        //         i.endPlace = i.goodsRtnVos[0].endPlace;
        //         i.beginTime = i.goodsRtnVos[0].beginTime;
        //         i.createTime = i.goodsRtnVos[0].createTime;
        //       }
        //     });
        //     this.sellerData2 = sellerData2;
        //     this.loading2 = false;
        //   });
      },
      async queryBuyerOrder() {
        // 获取列表数据
        this.loading3 = true;

        let path =
          this.userInfoValue.identityType === 0
            ? "queryOrdersBuyerList"
            : "queryOrdersBuyerListWithoutPermission";

        let res = await $api.ordersBuyer.post(path, {
          buyerOrdersNum: this.filterName3,
          page: this.page3.currentPage,
          rows: this.page3.pageSize,
          buyerName: this.orderName3,
          chainId: this.orderId ? this.orderId : null,
        });

        if (res) {
          this.page3.totalResult = res.data.total;
          let buyerData = res.data.rows;
          buyerData.map((i) => {
            if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
              i.goodsName = i.goodsRtnVos[0].goodsName;
              i.rule = i.goodsRtnVos[0].rule;
              i.unit = i.goodsRtnVos[0].unit;
              i.counts = i.goodsRtnVos[0].counts;
              i.price = i.goodsRtnVos[0].price;
              i.isTax = i.goodsRtnVos[0].isTax;
              i.carShipNum = i.goodsRtnVos[0].carShipNum;
              i.beginPlace = i.goodsRtnVos[0].beginPlace;
              i.endPlace = i.goodsRtnVos[0].endPlace;
              i.beginTime = i.goodsRtnVos[0].beginTime;
              i.createTime = i.goodsRtnVos[0].createTime;
            }
          });
          this.buyerData = buyerData;
          this.loading3 = false;
        }

        // $api.order.queryOrdersBuyerListWithoutPermission
        //   .POST({
        //     data: {
        //       buyerOrdersNum: this.filterName3,
        //       page: this.page3.currentPage,
        //       rows: this.page3.pageSize,
        //       buyerName: this.orderName3,
        //       chainId: this.orderId ? this.orderId : null,
        //     },
        //   })
        //   .then((res) => {
        //     this.page3.totalResult = res.data.total;
        //     let buyerData = res.data.rows;
        //     buyerData.map((i) => {
        //       if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
        //         i.goodsName = i.goodsRtnVos[0].goodsName;
        //         i.rule = i.goodsRtnVos[0].rule;
        //         i.unit = i.goodsRtnVos[0].unit;
        //         i.counts = i.goodsRtnVos[0].counts;
        //         i.price = i.goodsRtnVos[0].price;
        //         i.isTax = i.goodsRtnVos[0].isTax;
        //         i.carShipNum = i.goodsRtnVos[0].carShipNum;
        //         i.beginPlace = i.goodsRtnVos[0].beginPlace;
        //         i.endPlace = i.goodsRtnVos[0].endPlace;
        //         i.beginTime = i.goodsRtnVos[0].beginTime;
        //         i.createTime = i.goodsRtnVos[0].createTime;
        //       }
        //     });
        //     this.buyerData = buyerData;
        //     this.loading3 = false;
        //   });
      },
    },
  };
</script>

<style scoped>
  .btn-down {
    border: none;
    background: transparent;
  }

  .btn-down:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
  }
</style>